import React, { FC, Suspense, lazy } from "react";
import { Provider } from "react-redux";
import Store from "~/common/Store";

import { CustomizableModel, VariationDataResult } from "./types";
import useIsMounted from "~/common/useIsMounted";

const CustomizableTool = lazy(() => import("./CustomizableTool"));

interface CustomizableToolPageResult {
  customizableVariations: VariationDataResult;
  itemNumberId: number;
  items: Lookup<CustomizableModel>;
}

const CustomizableToolPage: FC<CustomizableToolPageResult> = ({
  customizableVariations,
  itemNumberId,
  items,
}) => {
  const mounted = useIsMounted();
  return (
    <Provider store={Store}>
      {mounted && (
        <Suspense fallback={<></>}>
          <CustomizableTool
            data={{
              items,
              itemNumberId,
              variationData: customizableVariations,
            }}
            mounted
          />
        </Suspense>
      )}
    </Provider>
  );
};

export default CustomizableToolPage;
